<template>
	<div class="iconContainer text-right">
		<span v-for="(icon, index) in data.icons" :key="index">
			<i v-if="icon.class.indexOf('mh-icon') > -1"
			   :class="icon.class"
			   :title="icon.title"
			   @click="icon.disabled !== false && iconOnClick(icon.emit)"
			   :disabled="icon.disabled === false"></i>
			<icon v-if="icon.class.indexOf('mh-icon') < 0"
				  :name="icon.class"
				  :title="icon.title"
				  class="m-3"
				  @click="icon.disabled !== false && iconOnClick(icon.emit)"
				  :disabled="icon.disabled === false"></icon>
		</span>
	</div>
</template>

<script>
	import { bus } from './../../main';

	export default {
		name: 'TableRowActions',
		props: {
			data: {}
		},
		methods: {
			iconOnClick: function (emit) {
				bus.$emit(emit, this.data)
			}
		}
	}
</script>

<style scoped>
	.iconContainer {
		white-space: nowrap;
	}
</style>